export enum D365AccountMigrated {
    SIEBEL = 100000000,
    D365 = 100000001,
    SIEBEL_BLOCCATO = 100000002,
    NOT_SET = 0,
}
